// brandhero
import BrandheroComputerDark from './brandhero/brandhero_computer_darkmode.svg?react';
import BrandheroComputerLight from './brandhero/brandhero_computer.svg?react';
import BrandheroOkDark from './brandhero/brandhero_ok_darkmode.svg?react';
import BrandheroOkLight from './brandhero/brandhero_ok.svg?react';
import BrandheroSadDark from './brandhero/brandhero_sad_dark.svg?react';
import BrandheroSadLight from './brandhero/brandhero_sad_light.svg?react';
import BrandheroWorkingOnComputerDark from './brandhero/brandhero_working_on_computer_dark.svg?react';
import BrandheroWorkingOnComputerLight from './brandhero/brandhero_working_on_computer_ligth.svg?react';
import BrandheroWorkspaceDark from './brandhero/brandhero_workspace_dark.svg?react';
import BrandheroWorkspaceLight from './brandhero/brandhero_workspace_light.svg?react';
// ctd
import BlockIcon from './ctd/block-icon.svg?react';
import CheckboxIcon from './ctd/checkbox-icon.svg?react';
import DateIcon from './ctd/date-icon.svg?react';
import EmailIcon from './ctd/email-icon.svg?react';
import GeoIcon from './ctd/geo-icon.svg?react';
import ListIcon from './ctd/list-icon.svg?react';
import MarkdownIcon from './ctd/markdown-icon.svg?react';
import MediaIcon from './ctd/media-icon.svg?react';
import NumberIcon from './ctd/number-icon.svg?react';
import RadioIcon from './ctd/radio-icon.svg?react';
import RelationIcon from './ctd/relation-icon.svg?react';
import RichTextIcon from './ctd/rich-text.svg?react';
import SelectIcon from './ctd/select-icon.svg?react';
import SimpleListIcon from './ctd/simple-list-icon.svg?react';
import TextIcon from './ctd/text-icon.svg?react';
import TextareaIcon from './ctd/textarea-icon.svg?react';
//graphics
import ListDocumentImage from './graphics/list-document.svg?react';
import ZoomMaleWorkingImage from './graphics/male-working.svg?react';
import PeopleWithHeartImage from './graphics/people-with-heart.svg?react';
import PricingImage from './graphics/pricing.svg?react';
import WarningFilledIcon from './icons-library/alerts/exclamation_circled_filled-icon.svg?react';
// alerts
import WarningIcon from './icons-library/alerts/exclamation_circled-icon.svg?react';
import WarningTriangleRedIcon from './icons-library/alerts/exclamation_triangle_red-icon.svg?react';
import WarningTriangleIcon from './icons-library/alerts/exclamation_triangle-icon.svg?react';
// arrows
import ArrowCollapseLeftIcon from './icons-library/arrows/arrow_collapse_left-icon.svg?react';
import ArrowCollapseRightIcon from './icons-library/arrows/arrow_collapse_right-icon.svg?react';
import ArrowFilledDownIcon from './icons-library/arrows/arrow_filled_down-icon.svg?react';
import ArrowLeftCurvedIcon from './icons-library/arrows/arrow_left_curved-icon.svg?react';
import ArrowLeftRightIcon from './icons-library/arrows/arrow_left_right-icon.svg?react';
import ArrowLeftThinIcon from './icons-library/arrows/arrow_left_thin-icon.svg?react';
import ArrowLeftIcon from './icons-library/arrows/arrow_left-icon.svg?react';
import ArrowRightCurvedThinIcon from './icons-library/arrows/arrow_right_curved_thin-icon.svg?react';
import ArrowRightCurvedIcon from './icons-library/arrows/arrow_right_curved-icon.svg?react';
import ArrowRightThinIcon from './icons-library/arrows/arrow_right_thin-icon.svg?react';
import ArrowRightIcon from './icons-library/arrows/arrow_right-icon.svg?react';
import ArrowUpRightIcon from './icons-library/arrows/arrow_up_right-icon.svg?react';
import ArrowUpThinIcon from './icons-library/arrows/arrow_up_thin-icon.svg?react';
import ArrowUpIcon from './icons-library/arrows/arrow_up-icon.svg?react';
//carets
import CaretDownSolidIcon from './icons-library/carets/caret_down_solid-icon.svg?react';
import CaretDownIcon from './icons-library/carets/caret_down-icon.svg?react';
import CaretLeftStopIcon from './icons-library/carets/caret_left_stop-icon.svg?react';
import CaretLeftIcon from './icons-library/carets/caret_left-icon.svg?react';
import CaretRightStopIcon from './icons-library/carets/caret_right_stop-icon.svg?react';
import CaretRightIcon from './icons-library/carets/caret_right-icon.svg?react';
import CaretUpIcon from './icons-library/carets/caret_up-icon.svg?react';
// Colorful misc
import CardPaymentIconWhite from './icons-library/color/card_payment-icon_white.svg?react';
import CardPaymentIcon from './icons-library/color/card_payment-icon.svg?react';
import ClipboardColorIconWhite from './icons-library/color/clipboard-icon_white.svg?react';
import ClipboardColorIcon from './icons-library/color/clipboard-icon.svg?react';
import ConnectedDotsColorIconWhite from './icons-library/color/connected_dots-icon_white.svg?react';
import ConnectedDotsColorIcon from './icons-library/color/connected_dots-icon.svg?react';
import CopyColorIconWhite from './icons-library/color/copy-icon_white.svg?react';
import CopyColorIcon from './icons-library/color/copy-icon.svg?react';
import FolderIconWhite from './icons-library/color/folder-icon_white.svg?react';
import FolderIcon from './icons-library/color/folder-icon.svg?react';
import FourSquaresColorWhite from './icons-library/color/four_squares-icon_white.svg?react';
import FourSquaresColor from './icons-library/color/four_squares-icon.svg?react';
import GearBoxIconWhite from './icons-library/color/gear-box-icon_white.svg?react';
import GearBoxColorIcon from './icons-library/color/gear-box-icon.svg?react';
import GearColorIconWhite from './icons-library/color/gear-icon_white.svg?react';
import GearColorIcon from './icons-library/color/gear-icon.svg?react';
import KeyColorIconWhite from './icons-library/color/key-icon_white.svg?react';
import KeyColorIcon from './icons-library/color/key-icon.svg?react';
import LifebuoyColorIconWhite from './icons-library/color/lifebuoy-icon_white.svg?react';
import LifebuoyColorIcon from './icons-library/color/lifebuoy-icon.svg?react';
import LightningCurrentColorIcon from './icons-library/color/lightning-current-color-icon.svg?react';
import LightningColorIconWhite from './icons-library/color/lightning-icon_white.svg?react';
import LightningColorIcon from './icons-library/color/lightning-icon.svg?react';
import MediaColorIconWhite from './icons-library/color/media-icon_white.svg?react';
import MediaColorIcon from './icons-library/color/media-icon.svg?react';
import MenuIconWhite from './icons-library/color/menu-icon-white.svg?react';
import MenuIcon from './icons-library/color/menu-icon.svg?react';
import PuzzleColorIconWhite from './icons-library/color/puzzle-icon_white.svg?react';
import PuzzleColorIcon from './icons-library/color/puzzle-icon.svg?react';
import QrCodeIcon from './icons-library/color/qr-icon.svg?react';
import TagsColorIconWhite from './icons-library/color/tags-icon_white.svg?react';
import TagsColorIcon from './icons-library/color/tags-icon.svg?react';
import UploadedFileIcon from './icons-library/color/uploaded-file-icon.svg?react';
import UsersCurrentColorIcon from './icons-library/color/users-current-color-icon.svg?react';
import UsersIconWhite from './icons-library/color/users-icon_white.svg?react';
import UsersIcon from './icons-library/color/users-icon.svg?react';
import UsersKeyIconWhite from './icons-library/color/users-key-icon_white.svg?react';
import UsersKeyIcon from './icons-library/color/users-key-icon.svg?react';
// Contact
import EnvelopeIcon from './icons-library/contact/envelope-icon.svg?react';
// controls
import AddVariantIcon from './icons-library/controls/add-variant-icon.svg?react';
import BoxDownloadIcon from './icons-library/controls/box_download-icon.svg?react';
import CenterIcon from './icons-library/controls/center-icon.svg?react';
import CloseIcon from './icons-library/controls/close-icon.svg?react';
import DownloadCircleIcon from './icons-library/controls/download-icon.svg?react';
import DragIcon from './icons-library/controls/drag-icon.svg?react';
import FilterListIcon from './icons-library/controls/filter-list.svg?react';
import LeaveIcon from './icons-library/controls/leave-icon.svg?react';
import ListViewIcon from './icons-library/controls/list-view-icon.svg?react';
import MaximizeIcon from './icons-library/controls/maximize-icon.svg?react';
import NewTabIcon from './icons-library/controls/new-tab-icon.svg?react';
import PlayCircleIcon from './icons-library/controls/play_circle-icon.svg?react';
import RefreshIcon from './icons-library/controls/refresh-icon.svg?react';
import ReloadIcon from './icons-library/controls/reload-icon.svg?react';
import ReplaceIcon from './icons-library/controls/replace-icon.svg?react';
import ResizeIcon from './icons-library/controls/resize-icon.svg?react';
import TilesViewIcon from './icons-library/controls/tiles-view-icon.svg?react';
import UpgradeIcon from './icons-library/controls/upgrade-icon.svg?react';
// Flags
import PolandFlagIcon from './icons-library/country-flags/poland_flag-icon.svg?react';
import UnitedKingdomFlagIcon from './icons-library/country-flags/united-kingdom_flag-icon.svg?react';
// Essentials
import BookIcon from './icons-library/essentials/book-icon.svg?react';
import BoxWithArrowIcon from './icons-library/essentials/box_with_arrow-icon.svg?react';
import CalendarIconBlue from './icons-library/essentials/calendar-icon_blue.svg?react';
import CalendarIcon from './icons-library/essentials/calendar-icon.svg?react';
import ClipboardIcon from './icons-library/essentials/clipboard-icon.svg?react';
import ClockIconBlue from './icons-library/essentials/clock-icon_blue.svg?react';
import ClockIcon from './icons-library/essentials/clock-icon.svg?react';
import CodeIcon from './icons-library/essentials/code-icon.svg?react';
import CopySolicIcon from './icons-library/essentials/copy-icon_solid.svg?react';
import CopyIcon from './icons-library/essentials/copy-icon.svg?react';
import DocumentIcon from './icons-library/essentials/document-icon.svg?react';
import DuplicateSolidIcon from './icons-library/essentials/duplicate_solid-icon.svg?react';
import DuplicateIcon from './icons-library/essentials/duplicate-icon.svg?react';
import StarFavWhiteIcon from './icons-library/essentials/favorite-star-icon_white.svg?react';
import StarFavIcon from './icons-library/essentials/favorite-star-icon.svg?react';
import FileIcon from './icons-library/essentials/file-icon.svg?react';
import FloppyDiskIcon from './icons-library/essentials/floppy_disk-icon.svg?react';
import FolderTabIcon from './icons-library/essentials/folder-tab-icon.svg?react';
import GridIcon from './icons-library/essentials/grid-icon.svg?react';
import HistoryIcon from './icons-library/essentials/history-icon.svg?react';
import HouseIcon from './icons-library/essentials/house-icon.svg?react';
import PreviewIcon from './icons-library/essentials/preview-icon.svg?react';
import StarIcon from './icons-library/essentials/star-icon.svg?react';
import TemplateIcon from './icons-library/essentials/template-icon.svg?react';
import WorldIcon from './icons-library/essentials/world-icon.svg?react';
// framework
import GatsbyIcon from './icons-library/framework/gatsby.svg?react';
import NextJSIcon from './icons-library/framework/nextjs.svg?react';
// Human
import EyeCrossedIcon from './icons-library/human/eye_crossed-icon.svg?react';
import EyeIcon from './icons-library/human/eye-icon.svg?react';
import AvatarIcon from './icons-library/human/user-icon.svg?react';
// internet
import DownloadIcon from './icons-library/internet/download-icon.svg?react';
import LinkIcon from './icons-library/internet/link-icon.svg?react';
import LogOutIcon from './icons-library/internet/log_out-icon.svg?react';
// Programming languages
import AngularLogo from './icons-library/programming-languages/angular-icon.svg?react';
import CSharpLogo from './icons-library/programming-languages/csharp-icon.svg?react';
import GatsbyLogo from './icons-library/programming-languages/gatsby-icon.svg?react';
import GoLogo from './icons-library/programming-languages/go-icon.svg?react';
import JavaLogo from './icons-library/programming-languages/java-icon.svg?react';
import NodeJsLogo from './icons-library/programming-languages/nodejs-icon.svg?react';
import PHPLogo from './icons-library/programming-languages/php-icon.svg?react';
import PostmanLogo from './icons-library/programming-languages/postman-icon.svg?react';
import PythonLogo from './icons-library/programming-languages/python-icon.svg?react';
import TypeScriptLogo from './icons-library/programming-languages/typescript-icon.svg?react';
// SocialMedia
import DiscordMarkIcon from './icons-library/social-media/color/discord_mark-icon.svg?react';
import DiscordColorIcon from './icons-library/social-media/color/discord-icon.svg?react';
import FacebookColorIcon from './icons-library/social-media/color/facebook-icon.svg?react';
import GithubColorIconWhite from './icons-library/social-media/color/github-icon_white.svg?react';
import GithubColorIcon from './icons-library/social-media/color/github-icon.svg?react';
import LinkedinColorIcon from './icons-library/social-media/color/linkedin-icon.svg?react';
import RedditColorIconWhite from './icons-library/social-media/color/reddit-icon_white.svg?react';
import RedditColorIcon from './icons-library/social-media/color/reddit-icon.svg?react';
import TwitterColorIcon from './icons-library/social-media/color/twitter-icon.svg?react';
import YoutubeColorIcon from './icons-library/social-media/color/youtube-icon.svg?react';
import DiscordWhiteIcon from './icons-library/social-media/white/discord_white-icon.svg?react';
import FacebookWhiteIcon from './icons-library/social-media/white/facebook_white-icon.svg?react';
import GithubWhiteIcon from './icons-library/social-media/white/github_white-icon.svg?react';
import GoogleWhiteIcon from './icons-library/social-media/white/google_white-icon.svg?react';
import LinkedinWhiteIcon from './icons-library/social-media/white/linkedin_white-icon.svg?react';
import RedditWhiteIcon from './icons-library/social-media/white/reddit_white-icon.svg?react';
import TwitterWhiteIcon from './icons-library/social-media/white/twitter_white-icon.svg?react';
import WindowsWhiteLogo from './icons-library/social-media/white/windows_white-icon.svg?react';
import YoutubeWhiteIcon from './icons-library/social-media/white/youtube_white-icon.svg?react';
// symbols
import CheckCircleIcon from './icons-library/symbols/checkbox_circle-icon.svg?react';
import CheckedCircleBorderedIcon from './icons-library/symbols/checked_circle-icon.svg?react';
import CheckmarkWhiteIcon from './icons-library/symbols/checkmark_white-icon.svg?react';
import CheckmarkIcon from './icons-library/symbols/checkmark-icon.svg?react';
import CrownIcon from './icons-library/symbols/crown-icon.svg?react';
import DotCrossedIconDarkMode from './icons-library/symbols/dot-crossed-dark-icon.svg?react';
import DotCrossedIcon from './icons-library/symbols/dot-crossed-icon.svg?react';
import DotIcon from './icons-library/symbols/dot-icon.svg?react';
import DotsIcon from './icons-library/symbols/dots-icon.svg?react';
import MinusIcon from './icons-library/symbols/minus-icon.svg?react';
import PlusDoubleCircleIcon from './icons-library/symbols/plus_double_circle-icon.svg?react';
import PlusCircleOutlineIcon from './icons-library/symbols/plus_outline-icon.svg?react';
import PlusSolidIcon from './icons-library/symbols/plus_solid-icon.svg?react';
import PlusIcon from './icons-library/symbols/plus-icon.svg?react';
import UnionIcon from './icons-library/symbols/union-icon.svg?react';
import EllipsisVerticalIcon from './icons-library/typography/ellipsis_vertical-icon.svg?react';
// typography
import EllipsisIcon from './icons-library/typography/ellipsis-icon.svg?react';
import InformationCircleIcon from './icons-library/typography/information_circle-icon.svg?react';
import InformationSignIcon from './icons-library/typography/information_sign-icon.svg?react';
import PencilSolidIcon from './icons-library/typography/pencil_solid-icon.svg?react';
import PencilSquareIcon from './icons-library/typography/pencil_square-icon.svg?react';
import PencilIcon from './icons-library/typography/pencil-icon.svg?react';
import QuestionMarkCircleIcon from './icons-library/typography/question_mark_circle-icon.svg?react';
import QuestionMarkWavedIcon from './icons-library/typography/question_mark_waved-icon.svg?react';
import QuestionMarkIcon from './icons-library/typography/question_mark-icon.svg?react';
import TagIcon from './icons-library/typography/tag-icon.svg?react';
import TagPlusIcon from './icons-library/typography/tag-plus-icon.svg?react';
// utilities
import AddBackgroundIcon from './icons-library/utilities/add_background_image-icon.svg?react';
import AddBorderIcon from './icons-library/utilities/add_border-icon.svg?react';
import BellIcon from './icons-library/utilities/bell-icon.svg?react';
import ComputerDesktopIcon from './icons-library/utilities/computer_desktop-icon.svg?react';
import DraggableRectanglesIcon from './icons-library/utilities/draggable-icon-rectangles.svg?react';
import DraggableIcon from './icons-library/utilities/draggable-icon.svg?react';
import ExportIcon from './icons-library/utilities/export-icon.svg?react';
import GearIcon from './icons-library/utilities/gear-icon.svg?react';
import ImportIconCircle from './icons-library/utilities/import-icon-circle.svg?react';
import ImportIcon from './icons-library/utilities/import-icon.svg?react';
import MagnifierIcon from './icons-library/utilities/magnifier-icon.svg?react';
import MagnifierSolidIcon from './icons-library/utilities/magnifier-solid-icon.svg?react';
import ReturnOldFrontWhite from './icons-library/utilities/return_old_front_white.svg?react';
import ReturnOldFront from './icons-library/utilities/return_old_front.svg?react';
import SectionsTilesIcon from './icons-library/utilities/sections-tiles.svg?react';
import SynchronizeIcon from './icons-library/utilities/synchronize-icon.svg?react';
import TrashIcon from './icons-library/utilities/trash_thin-icon.svg?react';
import TrashSolidIcon from './icons-library/utilities/trash-icon.svg?react';
// weather
import LightningIcon from './icons-library/weather/lightning-icon.svg?react';
import MoonIcon from './icons-library/weather/moon-icon.svg?react';
import SunIcon from './icons-library/weather/sun-icon.svg?react';
// loaders
import SpinnerGridIcon from './loaders/loader-grid.svg?react';
import SpinnerWhiteIcon from './loaders/loader-white.svg?react';
import SpinnerIcon from './loaders/loader.svg?react';
// logotypes
import AppSumoLogo from './logotypes/appsumo-logo.svg?react';
import CodeWaveWhiteLogo from './logotypes/codewave_white-logo.svg?react';
import CodeWaveLogo from './logotypes/codewave-logo.svg?react';
import CreditAgricoleWhiteLogo from './logotypes/credit-agricole_white-logo.svg?react';
import CreditAgricoleLogo from './logotypes/credit-agricole-logo.svg?react';
import FlotiqBadgeLogo from './logotypes/flotiq_badge-logo.svg?react';
import FlotiqLogoWhite from './logotypes/flotiq_white-logo.svg?react';
import FlotiqLogo from './logotypes/flotiq-logo.svg?react';
import GraphQLLogo from './logotypes/graphql-logo.svg?react';
import GriersonTrustWhiteLogo from './logotypes/grierson-trust_white-logo.svg?react';
import GriersonTrustLogo from './logotypes/grierson-trust-logo.svg?react';
import IteoWhiteLogo from './logotypes/iteo_white-logo.svg?react';
import IteoLogo from './logotypes/iteo-logo.svg?react';
import JTIWhiteLogo from './logotypes/jti_white-logo.svg?react';
import JTILogo from './logotypes/jti-logo.svg?react';
import PMIWhiteLogo from './logotypes/pmi_white-logo.svg?react';
import PMILogo from './logotypes/pmi-logo.svg?react';
import SurferWhiteLogo from './logotypes/surfer_white-logo.svg?react';
import SurferLogo from './logotypes/surfer-logo.svg?react';
import WoodenHamsterWhiteLogo from './logotypes/woodenhamster_white-logo.svg?react';
import WoodenHamsterLogo from './logotypes/woodenhamster-logo.svg?react';

export {
  // graphics
  ZoomMaleWorkingImage,
  ListDocumentImage,
  PricingImage,
  PeopleWithHeartImage,

  // alerts
  WarningIcon,
  WarningFilledIcon,
  WarningTriangleIcon,
  WarningTriangleRedIcon,

  // arrows
  ArrowLeftIcon,
  ArrowLeftThinIcon,
  ArrowLeftCurvedIcon,
  ArrowRightCurvedIcon,
  ArrowRightCurvedThinIcon,
  ArrowUpRightIcon,
  ArrowRightIcon,
  ArrowRightThinIcon,
  ArrowUpIcon,
  ArrowUpThinIcon,
  ArrowLeftRightIcon,
  ArrowCollapseLeftIcon,
  ArrowCollapseRightIcon,
  ArrowFilledDownIcon,

  //carets
  CaretLeftStopIcon,
  CaretLeftIcon,
  CaretRightStopIcon,
  CaretRightIcon,
  CaretUpIcon,
  CaretDownIcon,
  CaretDownSolidIcon,

  // Colorful misc
  ClipboardColorIcon,
  ClipboardColorIconWhite,
  ConnectedDotsColorIcon,
  ConnectedDotsColorIconWhite,
  CopyColorIcon,
  CopyColorIconWhite,
  FourSquaresColor,
  FourSquaresColorWhite,
  GearColorIcon,
  GearColorIconWhite,
  GearBoxIconWhite,
  GearBoxColorIcon,
  LifebuoyColorIcon,
  LifebuoyColorIconWhite,
  LightningColorIcon,
  LightningColorIconWhite,
  LightningCurrentColorIcon,
  KeyColorIcon,
  KeyColorIconWhite,
  MediaColorIcon,
  MediaColorIconWhite,
  TagsColorIcon,
  TagsColorIconWhite,
  MenuIcon,
  MenuIconWhite,
  PuzzleColorIcon,
  PuzzleColorIconWhite,
  QrCodeIcon,
  UsersCurrentColorIcon,
  UsersIcon,
  UsersIconWhite,
  UsersKeyIcon,
  UsersKeyIconWhite,
  FolderIcon,
  FolderIconWhite,
  CardPaymentIcon,
  CardPaymentIconWhite,
  UploadedFileIcon,

  // Contacts
  EnvelopeIcon,

  // controls
  RefreshIcon,
  ReloadIcon,
  ResizeIcon,
  PlayCircleIcon,
  CloseIcon,
  ListViewIcon,
  TilesViewIcon,
  DownloadCircleIcon,
  CenterIcon,
  MaximizeIcon,
  AddVariantIcon,
  DragIcon,
  UpgradeIcon,
  BoxDownloadIcon,
  LeaveIcon,
  ReplaceIcon,
  NewTabIcon,
  FilterListIcon,

  // Flags
  PolandFlagIcon,
  UnitedKingdomFlagIcon,

  // Essentials
  BookIcon,
  CalendarIcon,
  CalendarIconBlue,
  ClipboardIcon,
  CodeIcon,
  CopyIcon,
  CopySolicIcon,
  DuplicateIcon,
  DuplicateSolidIcon,
  DocumentIcon,
  ClockIcon,
  ClockIconBlue,
  FileIcon,
  FolderTabIcon,
  HistoryIcon,
  HouseIcon,
  StarIcon,
  StarFavIcon,
  StarFavWhiteIcon,

  // Human
  EyeCrossedIcon,
  EyeIcon,
  AvatarIcon,

  // internet
  DownloadIcon,
  LinkIcon,
  LogOutIcon,

  // Programming languages
  AngularLogo,
  CSharpLogo,
  GoLogo,
  JavaLogo,
  NodeJsLogo,
  PHPLogo,
  PostmanLogo,
  PythonLogo,
  GatsbyLogo,
  TypeScriptLogo,

  // SocialMedia
  DiscordMarkIcon,
  DiscordColorIcon,
  FacebookColorIcon,
  GithubColorIcon,
  GithubColorIconWhite,
  LinkedinColorIcon,
  RedditColorIcon,
  RedditColorIconWhite,
  TwitterColorIcon,
  YoutubeColorIcon,
  DiscordWhiteIcon,
  FacebookWhiteIcon,
  GithubWhiteIcon,
  LinkedinWhiteIcon,
  TwitterWhiteIcon,
  WindowsWhiteLogo,
  YoutubeWhiteIcon,
  GoogleWhiteIcon,
  RedditWhiteIcon,

  // symbols
  CheckCircleIcon,
  CheckedCircleBorderedIcon,
  DotIcon,
  DotsIcon,
  DotCrossedIcon,
  DotCrossedIconDarkMode,
  CheckmarkIcon,
  CheckmarkWhiteIcon,
  PlusIcon,
  PlusSolidIcon,
  PlusCircleOutlineIcon,
  PlusDoubleCircleIcon,
  UnionIcon,
  CrownIcon,
  MinusIcon,
  FloppyDiskIcon,
  BoxWithArrowIcon,
  WorldIcon,
  PreviewIcon,
  TemplateIcon,
  GridIcon,

  // typography
  EllipsisIcon,
  EllipsisVerticalIcon,
  PencilSquareIcon,
  PencilIcon,
  PencilSolidIcon,
  QuestionMarkCircleIcon,
  QuestionMarkWavedIcon,
  QuestionMarkIcon,
  InformationCircleIcon,
  InformationSignIcon,
  TagIcon,
  TagPlusIcon,

  // utilities
  AddBackgroundIcon,
  AddBorderIcon,
  BellIcon,
  TrashIcon,
  TrashSolidIcon,
  ExportIcon,
  ImportIcon,
  ImportIconCircle,
  ComputerDesktopIcon,
  MagnifierIcon,
  MagnifierSolidIcon,
  GearIcon,
  ReturnOldFront,
  ReturnOldFrontWhite,
  SectionsTilesIcon,
  SynchronizeIcon,
  DraggableIcon,
  DraggableRectanglesIcon,

  // weather
  LightningIcon,
  SunIcon,
  MoonIcon,

  // loaders
  SpinnerGridIcon,
  SpinnerWhiteIcon,
  SpinnerIcon,

  // logotypes
  AppSumoLogo,
  CreditAgricoleLogo,
  CreditAgricoleWhiteLogo,
  CodeWaveLogo,
  CodeWaveWhiteLogo,
  JTILogo,
  JTIWhiteLogo,
  WoodenHamsterLogo,
  WoodenHamsterWhiteLogo,
  FlotiqLogo,
  FlotiqLogoWhite,
  FlotiqBadgeLogo,
  GriersonTrustLogo,
  GriersonTrustWhiteLogo,
  GraphQLLogo,
  IteoLogo,
  IteoWhiteLogo,
  PMILogo,
  PMIWhiteLogo,
  SurferLogo,
  SurferWhiteLogo,

  // ctd
  BlockIcon,
  CheckboxIcon,
  DateIcon,
  EmailIcon,
  GeoIcon,
  ListIcon,
  MarkdownIcon,
  MediaIcon,
  NumberIcon,
  RadioIcon,
  RelationIcon,
  RichTextIcon,
  SelectIcon,
  SimpleListIcon,
  TextIcon,
  TextareaIcon,

  // framework
  GatsbyIcon,
  NextJSIcon,

  // brandhero
  BrandheroSadLight,
  BrandheroSadDark,
  BrandheroWorkingOnComputerLight,
  BrandheroWorkingOnComputerDark,
  BrandheroWorkspaceLight,
  BrandheroWorkspaceDark,
  BrandheroComputerLight,
  BrandheroComputerDark,
  BrandheroOkLight,
  BrandheroOkDark,
};

// Aliases:

export const DeleteIcon = TrashIcon;
